import React, { forwardRef } from 'react'
import { Join } from '../../lib/utils'

interface BgWrapperProps {
  className?: string
  /** @deprecated Use `className`. Kept as an alias for back-compat. */
  classes?: string
  children?: React.ReactNode
  id?: string
}

/**
 * `<HeroBackground>` — Viewport-wide background wrapper for hero sections.
 * Lives behind hero content (`absolute inset-y-0 w-screen`).
 *
 * Server-component safe.
 */
export const HeroBackground = forwardRef<HTMLDivElement, BgWrapperProps>(
  ({ className = '', classes = '', children, id }, ref) => {
    return (
      <div
        ref={ref}
        id={id}
        aria-hidden="true"
        className={Join('absolute inset-0 overflow-hidden', classes, className)}
      >
        {children}
      </div>
    )
  },
)
HeroBackground.displayName = 'HeroBackground'

/**
 * `<SectionBackground>` — Background wrapper sized to its parent section
 * (`absolute inset-0 size-full`). Pair with `<Section>` (which is `relative
 * isolate`) for backgrounds that don't bleed beyond the section.
 *
 * Server-component safe.
 */
export const SectionBackground = forwardRef<HTMLDivElement, BgWrapperProps>(
  ({ className = '', classes = '', children, id }, ref) => {
    return (
      <div
        ref={ref}
        id={id}
        aria-hidden="true"
        className={Join(
          'absolute inset-0 size-full overflow-hidden',
          classes,
          className,
        )}
      >
        {children}
      </div>
    )
  },
)
SectionBackground.displayName = 'SectionBackground'
